import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import checkLinkedCard from "../../common/checkLinkedCard";
import api_comm from "../../common/lib";

export const getCardBalance = createAsyncThunk(
	"user/CardBalance",
	async (args, { getState }) => {
		const state = getState();

		try {
			let linkedCardResults = await checkLinkedCard(
				state.Login.Auth.session_token,
				state.Login.Auth.storemember_guid
			);

			let Balance = await api_comm(
				"get",
				`/finances/api/v2/bankcard/balance/sequence/${linkedCardResults.data.data.sequence_number}`,
				{},
				state.Login.Auth.session_token
			);

			return { ...Balance.data.data, ...linkedCardResults.data.data };
		} catch (e) {
			if (e.data.error) {
				console.log(e.data.data.error);
			}
			console.log("Error:::", e);
			return e?.message;
		}
	}
);

const initialState = {
	Balance: 0,
	hasLinkedCard: false,
	loading: true,
};

export const CardBalanceSlice = createSlice({
	name: "UserCardBalance",
	initialState,
	reducers: {
		setBalance: (state, action) => {
			state.Balance = action.payload;
		},
	},
	extraReducers: {
		[getCardBalance.pending]: (state, action) => {
			state.loading = true;
		},
		[getCardBalance.fulfilled]: (state, action) => {
			state.Balance = action.payload.balance;
			state.loading = false;
			state.hasLinkedCard = action.payload.card_linked;
		},
		[getCardBalance.rejected]: (state, action) => {
			state.Balance = 0;
			state.error = action.payload;
			state.loading = false;
			state.hasLinkedCard = false;
		},
	},
});

export const { setBalance } = CardBalanceSlice.actions;

export default CardBalanceSlice.reducer;
